var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarehouseReleases = function SvgWarehouseReleases(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M15.5 16.5H18v2.465m-.381-2.465a6.66 6.66 0 0 1-2.646 2.682A6.57 6.57 0 0 1 6 16.5M12 7V3M3 13V7.828a2 2 0 0 1 .586-1.414l2.828-2.828A2 2 0 0 1 7.828 3h8.344a2 2 0 0 1 1.414.586l2.828 2.828A2 2 0 0 1 21 7.828V13M3.183 7h17.635",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgWarehouseReleases;